function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.409 31.1127C37.41 31.0864 37.4104 31.0603 37.4104 31.0345C37.4097 30.3762 37.1425 29.7452 36.6676 29.2797C36.1927 28.8143 35.5489 28.5525 34.8772 28.5517V17.069L37.1571 15.3931C37.2363 15.3349 37.3005 15.2593 37.3444 15.1724C37.3884 15.0855 37.411 14.9897 37.4104 14.8927C37.4098 14.7957 37.386 14.7002 37.3409 14.6138C37.2958 14.5275 37.2307 14.4527 37.1508 14.3954L31.7108 10.4991V3.72414C31.8787 3.72414 32.0398 3.65874 32.1586 3.54234C32.2773 3.42594 32.3441 3.26807 32.3441 3.10345V0.62069C32.3441 0.456072 32.2773 0.298198 32.1586 0.181796C32.0398 0.0653939 31.8787 0 31.7108 0H25.3778C25.2098 0 25.0487 0.0653939 24.93 0.181796C24.8112 0.298198 24.7445 0.456072 24.7445 0.62069V3.10345C24.7445 3.26807 24.8112 3.42594 24.93 3.54234C25.0487 3.65874 25.2098 3.72414 25.3778 3.72414V5.96335L20.685 2.60232C20.5766 2.52464 20.4457 2.48278 20.3114 2.48278C20.1771 2.48278 20.0462 2.52464 19.9378 2.60232L3.47203 14.3954C3.39211 14.4527 3.327 14.5275 3.28191 14.6138C3.23682 14.7002 3.21301 14.7957 3.2124 14.8927C3.21178 14.9897 3.23438 15.0855 3.27836 15.1724C3.32235 15.2593 3.38651 15.3349 3.46569 15.3931L5.74556 17.069V28.5517C5.07395 28.5525 4.43006 28.8143 3.95516 29.2797C3.48026 29.7452 3.21313 30.3762 3.21237 31.0345C3.21237 31.0603 3.21285 31.0864 3.2138 31.1127C2.61635 31.2632 2.09549 31.6223 1.74894 32.1225C1.40238 32.6226 1.25396 33.2295 1.3315 33.8293C1.40905 34.4291 1.70724 34.9806 2.17013 35.3802C2.63302 35.7799 3.2288 36.0003 3.84567 36H36.7771C37.394 36.0003 37.9898 35.7799 38.4527 35.3802C38.9156 34.9806 39.2138 34.4291 39.2913 33.8293C39.3688 33.2295 39.2204 32.6226 38.8739 32.1225C38.5273 31.6223 38.0064 31.2632 37.409 31.1127V31.1127ZM26.0111 1.24138H31.0775V2.48276H26.0111V1.24138ZM26.6444 6.82759V3.72414H30.4442V9.59198L26.5844 6.82759H26.6444ZM20.3114 3.87217L35.7128 14.9031L34.2382 15.987L20.6839 6.3256C20.5757 6.24843 20.4453 6.20685 20.3114 6.20685C20.1775 6.20685 20.0471 6.24843 19.9389 6.3256L6.38464 15.987L4.91001 14.9031L20.3114 3.87217ZM2.57908 33.5172C2.57943 33.1913 2.71039 32.8786 2.94374 32.6464C3.1771 32.4142 3.49418 32.2811 3.82667 32.2759H3.82818C3.86055 32.2803 3.89293 32.2841 3.92594 32.2862C4.03089 32.2927 4.13583 32.2734 4.2313 32.2302C4.32677 32.187 4.40977 32.1212 4.47279 32.0387C4.53581 31.9562 4.57688 31.8596 4.59229 31.7577C4.6077 31.6557 4.59697 31.5516 4.56106 31.4548C4.50865 31.3205 4.48086 31.1782 4.47897 31.0345C4.47937 30.7054 4.61294 30.3898 4.85039 30.1571C5.08783 29.9244 5.40976 29.7935 5.74556 29.7931V34.7586H3.84567C3.50987 34.7582 3.18794 34.6273 2.95049 34.3946C2.71305 34.1619 2.57948 33.8464 2.57908 33.5172V33.5172ZM29.8109 34.7586H22.2113V21.1034H29.8109V34.7586ZM31.0775 34.7586V20.4828C31.0775 20.3181 31.0107 20.1603 30.892 20.0439C30.7732 19.9275 30.6121 19.8621 30.4442 19.8621H21.578C21.41 19.8621 21.249 19.9275 21.1302 20.0439C21.0114 20.1603 20.9447 20.3181 20.9447 20.4828V34.7586H7.01216V17.0747L20.3114 7.59507L33.6106 17.0747V34.7586H31.0775ZM36.7771 34.7586H34.8772V29.7931C35.213 29.7935 35.535 29.9244 35.7724 30.1571C36.0099 30.3898 36.1434 30.7054 36.1438 31.0345C36.142 31.1783 36.1142 31.3207 36.0617 31.4551C36.0258 31.5519 36.0151 31.656 36.0305 31.758C36.0459 31.8599 36.087 31.9565 36.15 32.039C36.213 32.1215 36.296 32.1874 36.3915 32.2306C36.487 32.2738 36.5919 32.293 36.6969 32.2865C36.7299 32.2844 36.7622 32.2806 36.7946 32.2762H36.7961C37.1321 32.2786 37.4532 32.4118 37.689 32.6463C37.9247 32.8809 38.0557 33.1976 38.0532 33.5269C38.0507 33.8561 37.9148 34.1709 37.6755 34.4019C37.4362 34.633 37.1131 34.7614 36.7771 34.7589V34.7586Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.7782 19.8621H10.1786C10.0107 19.8621 9.8496 19.9275 9.73084 20.0439C9.61207 20.1603 9.54535 20.3181 9.54535 20.4828V29.1724C9.54535 29.337 9.61207 29.4949 9.73084 29.6113C9.8496 29.7277 10.0107 29.7931 10.1786 29.7931H17.7782C17.9462 29.7931 18.1073 29.7277 18.226 29.6113C18.3448 29.4949 18.4115 29.337 18.4115 29.1724V20.4828C18.4115 20.3181 18.3448 20.1603 18.226 20.0439C18.1073 19.9275 17.9462 19.8621 17.7782 19.8621ZM17.1449 24.2069H14.6117V21.1034H17.1449V24.2069ZM13.3451 21.1034V24.2069H10.8119V21.1034H13.3451ZM10.8119 25.4483H13.3451V28.5517H10.8119V25.4483ZM14.6117 28.5517V25.4483H17.1449V28.5517H14.6117Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.6963 27.5479C24.8302 27.2311 24.6767 26.8681 24.3536 26.7369C24.0305 26.6057 23.66 26.7561 23.5262 27.0728C23.3923 27.3895 23.5458 27.7526 23.8689 27.8838C24.192 28.015 24.5625 27.8646 24.6963 27.5479Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -2.6886,
  y: 0,
  width: 46,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 5.54535,
  y: 19.8621,
  width: 16.8662,
  height: 17.931,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d",
  x: 19.4778,
  y: 26.6895,
  width: 9.26693,
  height: 9.24171,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.1bef1a80.svg";
export { ForwardRef as ReactComponent };